import { selectUserProps } from 'services/events/selectors'
import { selectLoggedIn } from 'services/user/selectors'
import { selectPathname } from 'services/routing/selectors'
import { EventTypes } from '@uacf/web-client-events'

export default function configureActionListeners (store, apis) {
  store.addActionListener('INIT', () => {
    const state = store.getState()
    const props = selectUserProps(state)
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)

    const userProps = {
      app_name: props.app_name,
      platform: props.platform,
      domain: 'mmf',
    }

    const eventProps = {
      page_name: pageName,
      login_status: loginStatus,
    }

    if (props.user_id) {
      Object.assign(userProps, {
        age_group: props.age_group,
        user_id: props.user_id,
        city: props.user_city,
        country_code: props.user_country,
      })
    }

    apis.clientEventManager.updateUserProperties(userProps)
    apis.clientEventManager.logEvent(EventTypes.__INIT__)
    apis.clientEventManager.logEvent('page_viewed', eventProps)
  })

  store.addActionListener('@@router/LOCATION_CHANGE', () => {
    const state = store.getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)

    const eventProps = {
      page_name: pageName,
      login_status: loginStatus,
    }

    apis.clientEventManager.logEvent('page_viewed', eventProps)

    switch (pageName) {
      case '/auth/forgot_password':
        apis.clientEventManager.logEvent('forgot_pw_tapped')
        break
      default:
    }
  })

  store.addActionListener('INITIATE_COUNTRY_CONFIRMATION', (action) => {
    const eventProps = {
      screen_name: 'privacy_center_region',
      country_selected: action.payload,
    }

    apis.clientEventManager.logEvent('edit_location_tapped', eventProps)
  })

  store.addActionListener('DEACTIVATE_USER_SUCCESS', () => {
    const state = store.getState()
    const entryPoint = state.consents.stagedScreenName
    const appName = state.site.name
    const eventProps = {
      screen_name: 'delete_account',
      app_name: appName,
      entry_point: entryPoint,
    }

    apis.clientEventManager.logEvent('account_deleted', eventProps)
  })

  store.addActionListener('GET_FB_PROFILE_SUCCESS', () => {
    const state = store.getState()
    const fbProfile = state.auth.fbProfile
    const eventProps = {
      facebook_profile_permission: fbProfile ? 'true' : 'false',
      facebook_email_permission: fbProfile.email ? 'true' : 'false',
      facebook_birthday_permission: fbProfile.birthday ? 'true' : 'false',
    }

    apis.clientEventManager.logEvent('facebook_permission_requested', eventProps)
  })

  store.addActionListener('LOGIN_WITH_FACEBOOK_LOADING', () => {
    const eventProps = {
      entry_point: 'fb_auth',
    }
    apis.clientEventManager.logEvent('login_tapped', eventProps)
  })

  store.addActionListener('CONNECT_FACEBOOK_ERROR', () => {
    const state = store.getState()
    const fbStatus = state.auth.fbStatus
    const eventProps = {
      facebook_profile_permission: fbStatus,
      facebook_email_permission: fbStatus,
      facebook_birthday_permission: fbStatus,
    }

    apis.clientEventManager.logEvent('facebook_permission_requested', eventProps)
  })

  store.addActionListener('LOGIN_SUCCESS', () => {
    apis.clientEventManager.logEvent('login_attempted', { attempt_result: 'success' })
  })

  store.addActionListener('REQUEST_PASSWORD_RESET_SUCCESS', () => {
    apis.clientEventManager.logEvent('reset_pw_attempted', { attempt_result: 'success' })
  })

  store.addActionListener('SIGNUP_SUCCESS', () => {
    apis.clientEventManager.logEvent('signup_attempted', { attempt_result: 'success' })
  })

  store.addActionListener('CREATE_WORKOUT_SUCCESS', () => {
    const state = store.getState()
    const selectedActivityType = state.form.workoutForm.values.activityType
    const activityTypes = state.activityTypes.types
    const activityType = activityTypes.find((type) => {
      return type._links.self && (type._links.self[0].id === selectedActivityType)
    })
    const eventAttr = {
      activityType: activityType.name,
    }
    if (activityType._links.parent && activityType._links.parent[0].id) {
      const parentActivityType = activityTypes.find((type) => {
        return type._links.self && (type._links.self[0].id === activityType._links.parent[0].id)
      })
      eventAttr.parent_activity_type = parentActivityType.name
    }
    if (activityType._links.root && activityType._links.root[0].id) {
      const rootActivityType = activityTypes.find((type) => {
        return type._links.self && (type._links.self[0].id === activityType._links.root[0].id)
      })
      eventAttr.root_activity_type = rootActivityType.name
    }
    apis.clientEventManager.logEvent('workout_logged', eventAttr)
  })

  store.addActionListener('@@redux-form/SET_SUBMIT_FAILED', (action) => {
    const state = store.getState()
    let attempResult = ''
    switch (action.meta.form) {
      case 'login': {
        const loginForm = state.form.login
        if (loginForm.error) {
          attempResult = loginForm.error === 'access_denied' ? 'incorrect_email_or_pw' : loginForm.error
        } else if (loginForm.syncErrors) {
          attempResult = Object.keys(loginForm.syncErrors).map((key) => `blank_${key}`).toString()
        }
        apis.clientEventManager.logEvent('login_attempted', { attempt_result: attempResult })
        break
      }
      case 'forgotPassword': {
        const fpForm = state.form.forgotPassword
        if (fpForm.syncErrors && fpForm.syncErrors.email) {
          attempResult = fpForm.syncErrors.email === 'required' ? 'blank_email' : 'invalid_email'
          apis.clientEventManager.logEvent('reset_pw_attempted', { attempt_result: attempResult })
        }
        break
      }
      case 'signup': {
        const signupForm = state.form.signup
        if (signupForm.error) {
          attempResult = signupForm.error
        } else if (signupForm.syncErrors) {
          attempResult = Object.keys(signupForm.syncErrors).map((key) => `blank_${key}`).toString()
        }
        apis.clientEventManager.logEvent('signup_attempted', { attempt_result: attempResult })
        break
      }
      default:
    }
  })

  store.addActionListener('BUTTON_CLICKED_EVENT', (action) => {
    const state = store.getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)
    apis.clientEventManager.logEvent('button_clicked', {
      page_name: pageName,
      login_status: loginStatus,
      button_name: action.payload.buttonName,
      link: action.payload.link,
    })
  })

  store.addActionListener('LINK_CLICKED_EVENT', (action) => {
    const state = store.getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)
    apis.clientEventManager.logEvent('link_clicked', {
      page_name: pageName,
      login_status: loginStatus,
      link: action.payload.link,
    })
  })

  store.addActionListener('BLOG_CLICKED_EVENT', (action) => {
    const state = store.getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)
    apis.clientEventManager.logEvent('blog_clicked', {
      page_name: pageName,
      login_status: loginStatus,
      link: action.payload.link,
    })
  })

}
